(function () {
  'use strict';

  /* ===== Image Gallery ===== */
  const main = document.querySelector('[data-ds-main-image]');
  const slider = document.querySelector('[data-ds-slider]');
  const dotsWrap = document.querySelector('[data-ds-dots]');
  const thumbsWrap = document.querySelector('[data-ds-thumbs]');

  // Re-queried live each time — the gallery is rebuilt when the selected variant has its own photo set.
  const getSlides = () => document.querySelectorAll('[data-ds-image-slide]');
  const getThumbs = () => document.querySelectorAll('[data-ds-thumb]');
  const getDots = () => document.querySelectorAll('[data-ds-dot]');

  function showSlide(idx, scroll = true) {
    getSlides().forEach(s => {
      const active = parseInt(s.dataset.index) === idx;
      s.classList.toggle('is-active', active);
      if (!active) {
        const video = s.tagName === 'VIDEO' ? s : s.querySelector('video, iframe');
        if (video && video.tagName === 'VIDEO') video.pause();
        if (video && video.tagName === 'IFRAME' && video.src) video.src = video.src; // eslint-disable-line no-self-assign
      }
    });
    getThumbs().forEach(t => t.classList.toggle('is-active', parseInt(t.dataset.index) === idx));
    getDots().forEach(d => d.classList.toggle('is-active', parseInt(d.dataset.index) === idx));
    // On mobile the gallery is a horizontal-scroll strip — only scrollTo moves it.
    if (scroll && slider && slider.clientWidth > 0) {
      slider.scrollTo({ left: idx * slider.clientWidth, behavior: 'smooth' });
    }
  }

  function bindGalleryClicks() {
    getThumbs().forEach(t => { t.onclick = () => showSlide(parseInt(t.dataset.index)); });
    getDots().forEach(d => { d.onclick = () => showSlide(parseInt(d.dataset.index)); });
  }
  bindGalleryClicks();

  if (slider) {
    let scrollTimer;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (slider.clientWidth === 0 || slider.scrollWidth <= slider.clientWidth) return;
        showSlide(Math.round(slider.scrollLeft / slider.clientWidth), false);
      }, 80);
    }, { passive: true });
  }

  /* Per-variant photo sets + descriptions (data emitted by ds-product.liquid) */
  const galleryOriginal = {
    slider: slider ? slider.innerHTML : '',
    dots: dotsWrap ? dotsWrap.innerHTML : '', dotsHidden: dotsWrap ? dotsWrap.hidden : true,
    thumbs: thumbsWrap ? thumbsWrap.innerHTML : '', thumbsHidden: thumbsWrap ? thumbsWrap.hidden : true
  };
  let galleryShown = 'original';
  const dsAltByFile = {};
  const dsFileKey = u => (u || '').split('?')[0].split('/').pop();
  const dsSized = (u, w) => `${u}${u.indexOf('?') > -1 ? '&' : '?'}width=${w}`;

  function rebuildGallery(urls, altText) {
    if (!slider || !urls || !urls.length) return;
    slider.querySelectorAll('img[data-ds-image-slide]').forEach(im => {
      const k = dsFileKey(im.getAttribute('src'));
      if (k && im.alt && !(k in dsAltByFile)) dsAltByFile[k] = im.alt;
    });
    const fallbackAlt = altText || '';
    slider.innerHTML = urls.map((url, i) => `
      <img src="${dsSized(url, 800)}"
           srcset="${dsSized(url, 600)} 600w, ${dsSized(url, 1000)} 1000w, ${dsSized(url, 1400)} 1400w"
           sizes="(max-width: 900px) 100vw, 600px"
           alt="${(dsAltByFile[dsFileKey(url)] || fallbackAlt).replace(/"/g, '&quot;')}"
           loading="${i === 0 ? 'eager' : 'lazy'}"
           data-ds-image-slide data-index="${i}"
           class="${i === 0 ? 'is-active' : ''}"
           width="800" height="800">`).join('');
    const multi = urls.length > 1;
    if (dotsWrap) {
      dotsWrap.hidden = !multi;
      dotsWrap.innerHTML = multi ? urls.map((_, i) => `<button type="button" class="ds-pdp__dot ${i === 0 ? 'is-active' : ''}" data-ds-dot data-index="${i}" aria-label="Go to image ${i + 1}"></button>`).join('') : '';
    }
    if (thumbsWrap) {
      thumbsWrap.hidden = !multi;
      thumbsWrap.innerHTML = multi ? urls.map((url, i) => `
        <button type="button" class="ds-pdp__thumb ${i === 0 ? 'is-active' : ''}" data-ds-thumb data-index="${i}" aria-label="View image ${i + 1}">
          <img src="${dsSized(url, 160)}" alt="" loading="lazy" width="80" height="80">
        </button>`).join('') : '';
    }
    bindGalleryClicks();
    if (slider.scrollTo) slider.scrollTo({ left: 0, behavior: 'instant' });
  }

  function restoreGallery() {
    if (galleryShown === 'original' || !slider) return;
    slider.innerHTML = galleryOriginal.slider;
    if (dotsWrap) { dotsWrap.innerHTML = galleryOriginal.dots; dotsWrap.hidden = galleryOriginal.dotsHidden; }
    if (thumbsWrap) { thumbsWrap.innerHTML = galleryOriginal.thumbs; thumbsWrap.hidden = galleryOriginal.thumbsHidden; }
    bindGalleryClicks();
    galleryShown = 'original';
  }

  const descEl = document.querySelector('[data-ds-description]');
  const descOriginal = descEl ? descEl.innerHTML : '';
  const dsJson = sel => {
    const el = document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };

  function applyVariantMedia(opt) {
    if (!opt) return;
    const urls = dsJson(`[data-variant-gallery-id="${opt.value}"]`);
    if (urls && urls.length) {
      if (galleryShown !== opt.value) {
        rebuildGallery(urls, (opt.textContent || '').trim());
        galleryShown = opt.value;
      }
    } else {
      restoreGallery();
      const imgIndex = parseInt(opt.dataset.imageIndex);
      if (!isNaN(imgIndex) && imgIndex >= 0) showSlide(imgIndex);
    }
    if (descEl) {
      const html = dsJson(`[data-variant-description-id="${opt.value}"]`);
      descEl.innerHTML = html || descOriginal;
    }
  }

  /* ===== Quantity Stepper ===== */
  const qtyInput = document.querySelector('[data-ds-qty]');
  const qtyDown = document.querySelector('[data-ds-qty-down]');
  const qtyUp = document.querySelector('[data-ds-qty-up]');
  if (qtyDown && qtyInput) qtyDown.addEventListener('click', () => {
    const v = Math.max(1, parseInt(qtyInput.value) - 1);
    qtyInput.value = v;
  });
  if (qtyUp && qtyInput) qtyUp.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  /* ===== Variant Picker ===== */
  const optionPills = document.querySelectorAll('[data-ds-option]');
  const variantSelect = document.querySelector('[data-ds-variant-select]');

  function getSelectedOptions() {
    const selected = {};
    document.querySelectorAll('.ds-pdp__option-pill.is-active').forEach(p => {
      selected[p.dataset.optionPosition] = p.dataset.optionValue;
    });
    return selected;
  }

 function updateVariant() {
  if (!variantSelect) return;

  const selected = getSelectedOptions();
  const options = Array.from(variantSelect.options);

  const match = options.find(opt => dsOptMatches(opt, selected, 3));

  if (!match) {
    console.warn('No variant match found');
    return;
  }

  variantSelect.value = match.value;
  document.dispatchEvent(new CustomEvent('ds:variant-change', { detail: { id: match.value } }));

  applyVariantMedia(match);

  const price = parseInt(match.dataset.price);
  const comparePrice = parseInt(match.dataset.comparePrice) || 0;
  const available = match.dataset.available === 'true';

  const priceEl = document.querySelector('[data-ds-price-display]');
  if (priceEl) priceEl.textContent = formatMoney(price);

  const compareEl = document.querySelector('[data-ds-compare-display]');
  const savePillEl = document.querySelector('[data-ds-save-pill]');
  if (compareEl) {
    if (comparePrice > price) {
      compareEl.textContent = formatMoney(comparePrice);
      compareEl.style.display = '';
      if (savePillEl) {
        savePillEl.textContent = 'SAVE ' + formatMoney(comparePrice - price);
        savePillEl.style.display = '';
      }
    } else {
      compareEl.style.display = 'none';
      if (savePillEl) savePillEl.style.display = 'none';
    }
  }

  const stockWrap = document.querySelector('[data-ds-stock]');
  if (stockWrap) {
    const qty = parseInt(match.dataset.inventory, 10) || 0;
    const managed = match.dataset.managed === 'true';
    if (managed && qty > 0) {
      if (qty <= 10) {
        stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--low">
          <span class="ds-pdp__stock-dot"></span>
          Only <strong>${qty}</strong> left in stock — order soon
        </div>`;
      } else {
        stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--in">
          <span class="ds-pdp__stock-dot"></span>
          In stock — ready to dispatch from Riyadh
        </div>`;
      }
    } else {
      stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--out">
          <span class="ds-pdp__stock-dot"></span>
          Currently out of stock
        </div>`;
    }
  }

  const atcBtn = document.querySelector('[data-ds-atc]');
  const atcText = document.querySelector('.ds-pdp__atc-text');

  if (atcBtn) {
    atcBtn.disabled = !available;
    if (atcText) {
      atcText.textContent = available
        ? `Add to Cart — ${formatMoney(price)}`
        : 'Sold Out';
    }
  }
  const buyNowBtn = document.querySelector('[data-ds-buynow]');
  if (buyNowBtn) buyNowBtn.disabled = !available;
}

  
  // Exact match of a variant <option> against the selected values for positions 1..upTo
  function dsOptMatches(opt, selected, upTo) {
    for (let i = 1; i <= upTo; i++) {
      if (selected[i] !== undefined && (opt.dataset['o' + i] || '') !== selected[i]) return false;
    }
    return true;
  }

  function dsSetPill(pos, value) {
    document.querySelectorAll(`.ds-pdp__option-pill[data-option-position="${pos}"]`).forEach(p => {
      p.classList.toggle('is-active', p.dataset.optionValue === value);
    });
    const valueEl = document.querySelector(`[data-option-value="${pos}"]`);
    if (valueEl) valueEl.textContent = value;
  }

  // Each value is judged against the options ABOVE it (Size -> Paper -> Cover), so a customer is
  // never locked out: a value is disabled only if no variant has it with the higher selections.
  function dsRefreshPills() {
    if (!variantSelect) return;
    const options = Array.from(variantSelect.options);
    const selected = getSelectedOptions();
    optionPills.forEach(pill => {
      const pos = parseInt(pill.dataset.optionPosition, 10);
      const probe = {};
      for (let i = 1; i < pos; i++) if (selected[i] !== undefined) probe[i] = selected[i];
      probe[pos] = pill.dataset.optionValue;
      const hits = options.filter(o => dsOptMatches(o, probe, pos));
      const exists = hits.length > 0;
      const inStock = hits.some(o => o.dataset.available === 'true');
      pill.disabled = !exists;
      pill.classList.toggle('is-unavailable', !exists);
      pill.classList.toggle('is-soldout', exists && !inStock);
      pill.setAttribute('aria-disabled', exists ? 'false' : 'true');
      pill.title = !exists ? 'Not available in this combination' : (!inStock ? 'Sold out' : '');
    });
  }

  optionPills.forEach(pill => {
    pill.addEventListener('click', () => {
      if (pill.disabled) return;
      const pos = parseInt(pill.dataset.optionPosition, 10);
      dsSetPill(pos, pill.dataset.optionValue);
      // If the lower options no longer form a real variant, move them to the best real one
      // (prefer in stock) that keeps everything chosen up to this option.
      if (variantSelect) {
        const options = Array.from(variantSelect.options);
        const selected = getSelectedOptions();
        if (!options.some(o => dsOptMatches(o, selected, 3))) {
          const keep = options.filter(o => dsOptMatches(o, selected, pos));
          const pick = keep.find(o => o.dataset.available === 'true') || keep[0];
          if (pick) for (let i = pos + 1; i <= 3; i++) if (pick.dataset['o' + i]) dsSetPill(i, pick.dataset['o' + i]);
        }
      }
      updateVariant();
      dsRefreshPills();
    });
  });

  updateVariant();
  dsRefreshPills();

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const fmt = window.DS_MONEY_FORMAT || '£{{amount}}';
    return fmt.replace('{{amount}}', amount);
  }

  /* ===== Tabs ===== */
  const tabBtns = document.querySelectorAll('[data-ds-tab-trigger]');
  const tabPanels = document.querySelectorAll('[data-ds-tab-panel]');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.dsTabTrigger;
      tabBtns.forEach(b => b.classList.toggle('is-active', b === btn));
      tabPanels.forEach(p => p.classList.toggle('is-active', p.dataset.dsTabPanel === target));
    });
  });

  /* ===== Mobile Accordion (tabs collapse to accordion <=640px) ===== */
  document.querySelectorAll('[data-ds-acc]').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = document.querySelector(`[data-ds-tab-panel="${btn.dataset.dsAcc}"]`);
      const open = btn.classList.toggle('is-open');
      if (panel) panel.classList.toggle('is-open', open);
    });
  });

  /* ===== AJAX Add to Cart ===== */
  const form = document.getElementById('ds-product-form');
  const atcBtn = document.querySelector('[data-ds-atc]');

  if (form && atcBtn) {
    form.addEventListener('submit', function (e) {
      // Allow Buy Now (name="checkout") to submit normally
      if (e.submitter && e.submitter.name === 'checkout') return;

      e.preventDefault();
      const formData = new FormData(form);
      const originalText = atcBtn.querySelector('.ds-pdp__atc-text').textContent;
      atcBtn.dataset.loading = 'true';
      atcBtn.querySelector('.ds-pdp__atc-text').textContent = 'Adding…';

      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || 1, 10);

     fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  body: JSON.stringify({
    items: [{ id: parseInt(variantId, 10), quantity }],
    sections: 'cart-drawer,cart-icon-bubble',
    sections_url: window.location.pathname
  })
})
.then(async (r) => {
  const text = await r.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch(e) {
    console.error('Non-JSON response from /cart/add.js:', text.substring(0, 200));
    throw new Error('Cart error — unexpected server response');
  }
  if (!r.ok) throw new Error(data.description || 'Add to cart failed');
  return data;
})
.then(data => {
  atcBtn.dataset.loading = 'false';
  atcBtn.dataset.added = 'true';
  atcBtn.querySelector('.ds-pdp__atc-text').textContent = '✓ Added to Cart';

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && data.sections) {
    cartDrawer.renderContents({ id: variantId, sections: data.sections });
  }

  setTimeout(() => {
    atcBtn.dataset.added = 'false';
    atcBtn.querySelector('.ds-pdp__atc-text').textContent = originalText;
    atcBtn.disabled = false;
  }, 2500);
})
.catch(err => {
  atcBtn.dataset.loading = 'false';
  atcBtn.disabled = false;
  atcBtn.querySelector('.ds-pdp__atc-text').textContent = originalText;
  console.error('[DS ATC]', err.message);
  alert(err.message);
});
    });
  }


  /* ===== Sticky Mobile Bar ===== */
  const stickyBar = document.querySelector('[data-ds-sticky-bar]');
  const stickyAtc = document.querySelector('[data-ds-sticky-atc]');
  const mainAtc = document.querySelector('[data-ds-atc]');

   if (stickyBar && mainAtc) {
    let hasIntersected = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) hasIntersected = true;
        if (hasIntersected) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        }
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }
  if (stickyAtc && mainAtc) {
    stickyAtc.addEventListener('click', () => {
      mainAtc.click();
      window.scrollTo({ top: mainAtc.getBoundingClientRect().top + window.scrollY - 200, behavior: 'smooth' });
    });
  }
  /* ===== Initialize variant state on page load ===== */
(function initVariant() {
  const variantSelectEl = document.querySelector('[data-ds-variant-select]');
  if (!variantSelectEl) return;

  const selected = variantSelectEl.options[variantSelectEl.selectedIndex];
  if (!selected) return;
  applyVariantMedia(selected);

  const price     = parseInt(selected.dataset.price) || 0;
  const available = selected.dataset.available === 'true';
  const atcText   = document.querySelector('.ds-pdp__atc-text');
  const atcBtn    = document.querySelector('[data-ds-atc]');

  if (atcBtn) {
    atcBtn.disabled = !available;
    if (atcText) {
      atcText.textContent = available
        ? 'Add to Cart — ' + formatMoney(price)
        : 'Sold Out';
    }
  }
  const buyNowBtn = document.querySelector('[data-ds-buynow]');
  if (buyNowBtn) buyNowBtn.disabled = !available;
})();

  /* ===== Frequently Bought Together ===== */
  /* Widget is rendered server-side from precomputed metafields (see ds-product.liquid) —
     this just wires up the checkbox totals + combined add-to-cart. */
  (function initFBT() {
    const wrap = document.querySelector('[data-ds-fbt]');
    if (!wrap) return;

    const row = wrap.querySelector('[data-ds-fbt-row]');
    const totalEl = wrap.querySelector('[data-ds-fbt-total]');
    const totalOriginalEl = wrap.querySelector('[data-ds-fbt-total-original]');
    const savingsEl = wrap.querySelector('[data-ds-fbt-savings]');
    const addBtn = wrap.querySelector('[data-ds-fbt-add]');
    const checkboxes = row.querySelectorAll('[data-ds-fbt-check]');
    const discountPct = parseInt(wrap.dataset.dsFbtDiscountPct || '0', 10);

    function updateTotal() {
      const checked = Array.from(row.querySelectorAll('[data-ds-fbt-check]:checked'));
      const total = checked.reduce((sum, cb) => sum + parseInt(cb.dataset.price, 10), 0);

      const requiredCbs = Array.from(row.querySelectorAll('[data-ds-fbt-required]'));
      const allRequiredChecked = requiredCbs.length > 0 && requiredCbs.every(cb => cb.checked);

      if (discountPct > 0 && allRequiredChecked) {
        const discounted = Math.round(total * (100 - discountPct) / 100);
        totalOriginalEl.textContent = formatMoney(total);
        totalOriginalEl.hidden = false;
        totalEl.textContent = formatMoney(discounted);
        savingsEl.textContent = 'You save ' + formatMoney(total - discounted);
        savingsEl.hidden = false;
      } else {
        totalOriginalEl.hidden = true;
        totalEl.textContent = formatMoney(total);
        savingsEl.hidden = true;
      }

      addBtn.textContent = 'Add ' + checked.length + ' Item' + (checked.length !== 1 ? 's' : '') + ' to Cart';
      addBtn.disabled = checked.length < 2;
    }

    checkboxes.forEach(cb => cb.addEventListener('change', updateTotal));
    updateTotal();

    addBtn.addEventListener('click', () => {
      const checked = Array.from(row.querySelectorAll('[data-ds-fbt-check]:checked'));
      const cartItems = checked.map(cb => ({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 }));
      if (cartItems.length < 2) return;

      const originalText = addBtn.textContent;
      addBtn.dataset.loading = 'true';
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: cartItems, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      })
      .then(r => r.json())
      .then(data => {
        addBtn.dataset.loading = 'false';
        addBtn.textContent = '✓ Added';
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && data.sections) cartDrawer.renderContents({ sections: data.sections });
        setTimeout(() => { addBtn.textContent = originalText; }, 2000);
      })
      .catch(() => {
        addBtn.dataset.loading = 'false';
        addBtn.textContent = originalText;
      });
    });
  })();
})();
